import axiosInstance from "./axiosInstance";
import { showAlertError, showAlertExito } from '../utils/alertHelper';

const catalogo = "typeFactsToFacturate";


// listando tipo de documento que puede emitir el cliente
export const facturasCliente = async () => {
    try {
        const response = await axiosInstance.get(`/${catalogo}/list`);
        return response.data;
    } catch (error) {
        console.error("Error en listar tipo de documentos:", error);
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

export const facturasClienteAgregar = async (data) => {
    try {
        const response = await axiosInstance.post(`/${catalogo}/create`, data);
        return response.data;
    } catch (error) {
        console.error("Error en crear tipo de documentos a facturar:", error);
        showAlertError("Error inesperado", "Ocurrió un problema al guardar la configuración de facturación.");
    }
};

export const generarTokenDiario = async (data) => {
    try {
        const response = await axiosInstance.post(`/facturar/token/cliente`, data);
        showAlertExito("¡Éxito!", "Token actualizado exitosamente");
        return response.data;
    } catch (error) {
        console.error("Error en generar token diario:", error);
        showAlertError("Error inesperado", "Ocurrió un problema al generar el token diario.");
    }
};

    


